<script>
    export let number;
    export let question;
    export let answer;
    export let proofs;

    $: panelId = 'panel_' + number;

    let accordionClass = 'accordion-closed';

    function accordionClick() {
        if (accordionClass === 'accordion-closed') {
            accordionClass = 'accordion-open';
        }
        else {
            accordionClass = 'accordion-closed';
        }
    }
</script>

<main>
    <input type="radio" id={panelId} name="accordion-select" on:click={accordionClick}>

    <div class="panel is-link {accordionClass}">
        <label class="panel-heading panel-heading" for={panelId}>Pregunta {number}: {question}</label>
        <div class="panel-block body">
            <section class="section">
                <div class="title is-5">Respuesta: {answer}</div>
                <ol>
                    {#each proofs as { ref, text }}
                        <li>
                            <p>
                                <span class="p-ref">{ref}</span> - <span class="p-text">{text}</span>
                            </p>
                        </li>
                    {/each}
                </ol>
            </section>
        </div>
    </div>
</main>

<style>
    li {
        margin: 0.5em 0em;
    }

    /* Begin Accordion */
    input[name="accordion-select"], .panel-block {
      display: none;
    }

    label.panel-heading {
      cursor: pointer;
      display: block;
    }

    .accordion-closed .panel-block {
        display: none;
    }

    .accordion-open .body {
        display: flex;
    }

    .accordion-open .panel-heading {
        border-radius: 6px 6px 0px 0px;
    }
    /* End Accordion */

    .section {
        padding:  1rem 1.5rem;
    }

    .panel-heading {
        border-radius: 6px 6px;
        font-size: 1.0em;
    }

    .p-ref {
        font-weight: bold;
    }

    .panel {
        margin-bottom: 1.5em;
    }
</style>